/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthPatchOnboardingRequest, AuthPatchOnboardingResponse } from '../types/AuthPatchOnboarding'

/**
 * PATCH /auth/me/onboarding
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::patchOnboarding
 */
export async function authPatchOnboarding(
	data: AuthPatchOnboardingRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthPatchOnboardingResponse>> {
	return axiosInstance.patch('/auth/me/onboarding', data, config)
}
